import flatten from 'flat';
import Polyglot from 'node-polyglot';

import * as helpers from './helpers.js';
import * as i18nHelpers from './i18n-helpers.js';
import * as shopify from './shopify.js';
import * as state from './state.js';

let lang = '';
let polyglot = {};
let enToLangLookup = {};

async function init() {
  if (!shopify.isOnCart()) return;

  lang = state.getLanguageIso();

  await i18nHelpers.loadLanguages(lang, polyglot, 'shopify');

  i18nHelpers.translatePage(lang, polyglot, 'shopify');

  if (lang !== 'en' && shopify.isOnCheckout()) {
    let lookups = i18nHelpers.getLanguageLookup();
    lookups.en = flatten(lookups.en);
    lookups.lang = flatten(lookups.lang);

    for (let key in lookups.en) {
      let englishPhrase = lookups.en[key];
      let langPhrase = lookups.lang[key];
      if (!langPhrase) console.log('not found: ' + englishPhrase);
      enToLangLookup[englishPhrase] = langPhrase;
    }
    console.log(enToLangLookup);

    translateUnderElement(document.querySelector('body'));
    initObservation();
  }

  internationalizeLinks();
}



function internationalizeLinks() {
  let links = document.querySelectorAll('a');
  links.forEach((link) => {
    let url = link.getAttribute('href');

    if (url === null) return;

    if (i18nHelpers.urlContainsLanguage(url))
      return;  // don't mess with links that already have language (the
               // lang-picker links)

    let internationalizedUrl = internationalizeUrl(url);
    if (internationalizedUrl !== null) {
      link.setAttribute('href', internationalizedUrl);
    };
  });
}

function internationalizeUrl(url) {
  let www = helpers.getWwwRootUrl();
  // https://www.saleae.com

  if (!url.startsWith(www))
    return null;  // only need to worry about www urls for i18n; Shopify doesn't
                  // use url for language id

  let lang = state.getLanguageIso();
  if (lang === 'en') return null;  // normal url is what we want.

  // https://www.saleae.com
  // https://www.saleae.com/about

  let modifiedUrl = url.replace(www, `${www}/${lang}`);
  return modifiedUrl;
}



function translate(text) {
  text = text.trim();
  if (text.length === 0) return;

  // textNode could contain script or css contents, which isn't ideal.
  // however for now it's fine; there are only three of these on the checkout
  // page.

  text = text.replace(/\r?\n|\r/g, '');  // remove any line breaks
  text = text.replace(
      /\s+/g, ' ');  // collapse instances of whitespace to single spaces

  const translation = enToLangLookup[text];
  if (!translation) {
    console.log(`Translation not found for: '${text}'`);
    return null;
  }

  console.log(`'${text}' -> '${translation}'`);
  return translation;
}

function translateTextNode(textNode) {
  if (!textNode.textContent) return;

  const translation = translate(textNode.textContent);
  if (translation !== null) {
    textNode.textContent = translation;
  }
}

function translateElement(element) {
  if (!element.hasAttribute('placeholder')) return;

  const phrase = element.getAttribute('placeholder');
  const translation = translate(phrase);
  if (translation !== null) {
    element.setAttribute('placeholder', translation);
  }
}

function translateUnderElement(element) {
  let nodeArray = findTextNodesUnderElement(element);
  nodeArray.forEach(node => translateTextNode(node));

  let elementArray = findElementsUnderElement(element);
  elementArray.forEach(element => translateElement(element));
}

function findTextNodesUnderElement(element) {
  let walker =
      document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
  let node = {};
  let nodeArray = [];

  while (node = walker.nextNode()) {
    nodeArray.push(node);
  }
  return nodeArray;
}

function findElementsUnderElement(element) {
  let walker =
      document.createTreeWalker(element, NodeFilter.SHOW_ELEMENT, null, false);
  let elementArray = [];

  while (element = walker.nextNode()) {
    elementArray.push(element);
  }
  return elementArray;
}



function initObservation() {
  let mutationObserver = new MutationObserver((mutation) => {
    if (mutation.addedNodes) {
      mutation.addedNodes.forEach(node => translateUnderElement(node));
    }
    if (mutation.type === 'characterData') {
      translateTextNode(mutation.target);
    }
    if (mutation.type === 'attributes') {
      translateElement(mutation.target);
    }
  });

  const body = document.querySelector('body');
  const options = {childList: true, characterData: true, subtree: true};
  mutationObserver.observe(body, options);
}

export {
  init,
};
